var map = {
	"./custom/app/navbar/navbar.component": [
		90774,
		"src_themes_custom_app_navbar_navbar_component_ts"
	],
	"./dspace/app/navbar/navbar.component": [
		81533
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 67309;
module.exports = webpackAsyncContext;